import { TarjetaDeCredito } from 'src/app/pago/models/TarjetaDeCredito.model';

export class TarjetaDeCreditoBuilder {
  private franquicia: string;
  private cuotas: number;
  private numeroTarjeta: string;
  private codigoSeguridad: string;
  private fechaVencimiento: string;

  withFranquicia(franquicia: string) {
    this.franquicia = franquicia;
    return this;
  }

  withCuotas(cuotas: number) {
    this.cuotas = cuotas;
    return this;
  }

  withTNumeroTarjeta(numeroTarjeta: string) {
    this.numeroTarjeta = numeroTarjeta;
    return this;
  }

  withCodigoSeguridad(codigoSeguridad: string) {
    this.codigoSeguridad = codigoSeguridad;
    return this;
  }

  withFechaVencimiento(fechaVencimiento: string) {
    this.fechaVencimiento = fechaVencimiento;
    return this;
  }

  build(): TarjetaDeCredito {
    return {
      franquicia: this.franquicia,
      cuotas: this.cuotas,
      numeroTarjeta: this.numeroTarjeta,
      codigoSeguridad: this.codigoSeguridad,
      fechaVencimiento: this.fechaVencimiento,
    };
  }
}
